module.exports = __webpack_public_path__ + "static/media/management.7e7c3757.png";